import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get, split, last } from 'lodash';
import * as actions from '../../store/actions/dataLayer';
import { getPageParams } from '../../utils/dataLayerHelper';
import { getCurrentLocale } from '../../utils/language';

class DataLayer extends PureComponent {
  state = {}
  getFullPath = () => {
    const { location } = this.props;
    const pathname = get(location, 'pathname', '');
    const search = get(location, 'search', '');
    return `${pathname}${search}`;
  }
  componentDidMount(){
    this.updateDataLayer();
  }
  componentDidUpdate(){
    this.updateDataLayer();
    this.updatePostDataLayer();
  }
  updateDataLayer(){
    const fullPath = this.getFullPath();
    //only update Data Layer once per path change
    if (this.state.fullPath === fullPath) {
      return;
    }
    this.setState({ fullPath, isWorking: true });
    const pageType = get(this.props, 'pageType', 'default');
    const pageData = {
      ownerId: get(this.props, 'data.partyDetails.id', ''),
      category: get(this.props, 'match.params.category', ''),
      article: get(this.props, 'match.params.article', '')
    };
    const params = getPageParams(pageType, pageData);
    const locale = getCurrentLocale(true);
    params.country = last(split(locale, '-')) === 'GB' ? 'UK' : last(split(locale, '-'));
    this.props.initDataLayer(params);
  }
  updatePostDataLayer(){
    if (!this.state.isWorking) {
      return;
    }
    if (!this.props.isWorking) {
      this.setState({ isWorking: false });
      const fullPath = this.getFullPath();
      this.props.registerPageView({ pathname: fullPath });
      this.props.registerProductImpressions();
    }
  }
  render(){
    return null;
  }
}

DataLayer.propTypes = {
  initDataLayer: PropTypes.func.isRequired,
  isWorking: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  }),
  pageType: PropTypes.string,
  registerPageView: PropTypes.func.isRequired,
  registerProductImpressions: PropTypes.func.isRequired,
};

const connectedDataLayer = connect(
  state => ({
    isWorking: state.app.isWorking,
    data: state.app.data
  }),
  dispatch => bindActionCreators({
    ...actions,
  }, dispatch),
)(DataLayer);

const connectedToRouter = withRouter(connectedDataLayer);

export default connectedToRouter;
